import script from "./bottom-drawer.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./bottom-drawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./bottom-drawer.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./bottom-drawer.vue?vue&type=script&setup=true&lang=ts"

import "./bottom-drawer.vue.scss?vue&type=style&index=0&id=300807ff&lang=scss!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./bottom-drawer.vue?vue&type=style&index=0&id=300807ff&lang=scss"

const __exports__ = script;

export default __exports__